import { FALLBACK_LANGUAGE } from '../constants';

const translationsFiles = require.context('./translations', false, /translations.*\.json/i);

const vuejsExtranetTranslations = translationsFiles.keys().reduce((acc, filename) => {
    const matchedLanguage = filename.match(/translations_(\w+)\.json/);
    const language = matchedLanguage ? matchedLanguage[1] : FALLBACK_LANGUAGE;

    return {...acc, [language]: translationsFiles(filename)};
}, {});

export default vuejsExtranetTranslations;
